module.exports = __webpack_public_path__ + "img/minanlizhanshis.adf3b761.png";